import { CUSTOMER_SERVICE_PHONE_NUMBER, CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'

export const ErrorStep: FC = () => {
  const { t } = useTranslation('features-settings')

  return (
    <div className="rounded-md bg-alertErrorBg p-4">
      <p className="text-sm text-alertErrorText">
        {t('client_service.update_error')}
        <a
          href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
          title={t('client_service.call')}
          rel="noopener"
          className="text-sky-500 hover:underline font-bold"
        >
          {CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY}
        </a>
      </p>
    </div>
  )
}
